"use client";
import {
  Swiper as ThirdPartySwiper,
  SwiperProps as ThirdPartySwiperProps,
  SwiperSlide,
  useSwiper,
} from "swiper/react";

import {
  Pagination,
  Navigation,
  A11y,
  FreeMode,
  Thumbs,
  Autoplay,
  EffectFade
} from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/autoplay";

interface SwiperProps extends ThirdPartySwiperProps {
  className?: string;
  children?: React.ReactNode;
}

const Swiper = (props: SwiperProps) => {
  const { className, children, ...lastProps } = props;

  return (
    <ThirdPartySwiper
      className={className}
      modules={[
        Pagination,
        Navigation,
        A11y,
        FreeMode,
        Thumbs,
        Autoplay,
        EffectFade,
      ]}
      {...lastProps}
    >
      {children}
    </ThirdPartySwiper>
  );
};

export { SwiperSlide, useSwiper };

export default Swiper;
